const coreAdvantages = () => {
  return [
    {
      imgUrl: require("@/assets/images/about/core1.png"),
      title: "公司规模",
      content: "30+，技术团队占比90%以上，主力开发人员（3~10年）占比70%以上",
    },
    {
      imgUrl: require("@/assets/images/about/core2.png"),
      title: "核心班子",
      content: "专业领域工龄均在10+年以上，来自广联达、恒生电子、连连支付等著名的科技企业",
    },
    {
      imgUrl: require("@/assets/images/about/core3.png"),
      title: "技术能力",
      content: "拥有强大的移动APP、小程序、WEB、.Net、JAVA等设计、开发能力",
    },
  ];
};
const companyProfile = () => {
  return [
    {
      imgUrl: require("@/assets/images/about/profile1.png"),
      title: "泛钛科技",
      content: "杭州泛钛科技有限公司成立于2017年7月，注册地在于最具创业创新活力的杭州市。在以移动互联网、大数据、云计算、人工智能为代表的新一代信息化浪潮中，公司聚焦于泛金融大科技、政企数字化领域，以人才和技术为核心，以科技服务和技术VC为抓手，乘风破浪，扬帆起航。公司秉承“重诺守信、严谨求是”的企业精神和“以人为本，客户至上”的经营理念",
    },
    {
      imgUrl: require("@/assets/images/about/profile2.png"),
      title: "专业团队管理",
      content: "公司拥有一支在金融、互联网、IT行业经验特别丰富的团队，核心团队成员均来自蚂蚁金服、恒生电子、连连支付等著名的互联网科技企业。在分布式、微服务、大数据、云计算等技术领域，在支付清算、风险管理等业务领域，在企业运营、研发管理、质量管理等经营领域，都有很深的积累。",
    },
    {
      imgUrl: require("@/assets/images/about/profile3.png"),
      title: "技术服务体系",
      content: "在科技服务板块，公司以自主研发的二次开发技术平台为基础层，形成了以聚合支付、电子账户、流控审批等为业务公共层，消费金融、融资租赁、积分商城等为应用产品层的技术产品体系，并以此为基础形成了产品实施、项目外包、人力外包等多种形式的服务体系，自公司成立以来，相关产品及解决方案在多家金融机构落地，与传化支付、连连支付等知名金融服务企业有长期和良好的合作关系，并获得客户广泛好评。",
    },
  ];
};
export { coreAdvantages,companyProfile };
